var SENTRY_RELEASE;SENTRY_RELEASE={name: "Fruitful", version: "26.11.0"};